// extracted by mini-css-extract-plugin
module.exports = {"button":"a10a3f92e9--button--vL7zf","icon":"a10a3f92e9--icon--t73zm"};